<template>
    <rkm-modal
        :title="item ? `Dente - ${item.numero}` : null"
        extra-large
        ref="RkmModal"
    >
        <rkm-form v-if="model">
            <rkm-area
                no-margin-top
                title="Problemas/condições"
            >
                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-checkbox-group
                            :disabled="disabledProblemasCondicoesDenteInferior || disabledProblemasCondicoesDenteSuperior"
                            name="Problemas/condições"
                            v-model="model.problemasCondicoes"
                        >
                            <rkm-row>
                                <rkm-col
                                    v-for="problemaCondicao in problemasCondicoes"
                                    :key="problemaCondicao.id"
                                    cols="4"
                                >
                                    <rkm-form-checkbox
                                        :value="problemaCondicao.id"
                                        v-bind="handleProblemaCondicaoProps(problemaCondicao.id)"
                                    >
                                        {{problemaCondicao.nome}}
                                    </rkm-form-checkbox>
                                </rkm-col>
                            </rkm-row>
                        </rkm-form-checkbox-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        :disabled="model.problemasCondicoes.length === 0"
                        :options="dentes.filter(dente => dente.problemasCondicoes.length === 0)"
                        label="Replicar problemas/condições para outros dentes"
                        text-field="nome"
                        v-model="model.replicarProblemasCondicoesOutrosDentes"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-area
                no-margin-top
                title="Procedimentos"
            >
                <template slot="trailing">
                    <rkm-button
                        @click="$refs.ModalProcedimento.open()"
                        color="primary"
                        small
                        title="Adicionar"
                    >
                        <rkm-icon icon="plus" />
                    </rkm-button>
                </template>

                <ProcedimentoClinicoList
                    :data="{form: data.form, model}"
                    @edit="$refs.ModalProcedimento.open($event)"
                />
            </rkm-area>

            <rkm-row class="mt-3">
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        :disabled="model.procedimentosClinicos.length === 0"
                        :options="dentes"
                        label="Replicar procedimentos para outros dentes"
                        text-field="nome"
                        v-model="model.replicarProcedimentosOutrosDentes"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-textarea
                        :validations="validations.observacao"
                        label="Observações"
                        rows="6"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ProcedimentoClinicoModal
            :data="{form: data.form, model}"
            ref="ModalProcedimento"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import ProcedimentoClinicoList from '@/components/ambulatorio/acolhimento-saude-bucal/components/procedimento-clinico/List'
import ProcedimentoClinicoModal from '@/components/ambulatorio/acolhimento-saude-bucal/components/procedimento-clinico/Modal'

// Enums.
import saudeBucalDenteProblemaCondicao from '@/enums/ambulatorio/saudeBucalDenteProblemaCondicao'

// Mixins.
import {object} from '@/mixins'

export default {
    components: {ProcedimentoClinicoList, ProcedimentoClinicoModal},
    computed: {
        problemasCondicoes() {
            return this.data.form.odontograma.problemasCondicoes
        },
        disabledProblemasCondicoesDenteInferior() {
            return this.data.model.odontograma.protesesTotais.includes('inferior') &&
                (this.getDentesInferioresDeciduos().some(dente => dente.id === this.model.id) || this.getDentesInferioresPermanentes().some(dente => dente.id === this.model.id))
        },
        disabledProblemasCondicoesDenteSuperior() {
            return this.data.model.odontograma.protesesTotais.includes('superior') &&
                (this.getDentesSuperioresDeciduos().some(dente => dente.id === this.model.id) || this.getDentesSuperioresPermanentes().some(dente => dente.id === this.model.id))
        },
        dentes() {
            return this.getDentes()
        },
        validations() {
            return {
                observacao: {max: 5000},
            }
        },
    },
    data: () => ({
        enums: {saudeBucalDenteProblemaCondicao},
        item: null,
        model: null,
    }),
    methods: {
        open(item) {
            this.item = item

            this.edit()

            this.$refs.RkmModal.show()
        },
        edit() {
            this.model = Object.assign(this.clone(this.item), {
                replicarProblemasCondicoesOutrosDentes: [],
                replicarProcedimentosOutrosDentes: [],
            })
        },
        update() {
            if (this.model.problemasCondicoes.some(problemaCondicao => this.getProblemasCondicoesToDisable().includes(problemaCondicao))) {
                this.model.fragmentos = this.getIsTratadoNull()
            }

            this.includeProblemasCondicoesOutrosDentes()
            this.includeProcedimentosOutrosDentes()

            Object.assign(this.item, this.model)
        },
        getIsTratadoNull() {
            return {
                centro: {isTratado: null},
                cima: {isTratado: null},
                baixo: {isTratado: null},
                direita: {isTratado: null},
                esquerda: {isTratado: null},
            }
        },
        includeProblemasCondicoesOutrosDentes() {
            this.model.replicarProblemasCondicoesOutrosDentes.forEach(id => {
                const dente = this.getDentes().find(dente => dente.id === id)

                if (!dente) return

                if (this.model.problemasCondicoes.some(problemaCondicao => this.getProblemasCondicoesToDisable().includes(problemaCondicao))) {
                    dente.fragmentos = this.getIsTratadoNull()
                }

                dente.problemasCondicoes = [...this.model.problemasCondicoes]
            })
        },
        includeProcedimentosOutrosDentes() {
            this.model.replicarProcedimentosOutrosDentes.forEach(id => {
                const dente = this.getDentes().find(dente => dente.id === id)

                if (!dente) return

                this.model.procedimentosClinicos.forEach(procedimento => {
                    const hasProcedimento = dente.procedimentosClinicos.find(p => p.procedimento.id === procedimento.procedimento.id)

                    if (!hasProcedimento) {
                        dente.procedimentosClinicos.push(procedimento)
                    }
                })
            })
        },
        save() {
            this.update()

            this.$refs.RkmModal.hide()
        },
        handleProblemaCondicaoProps(id) {
            const props = {}

            const parte1 = [
                this.enums.saudeBucalDenteProblemaCondicao.AUSENTE_A,
                this.enums.saudeBucalDenteProblemaCondicao.EXTRAIDO_E,
                this.enums.saudeBucalDenteProblemaCondicao.HIGIDO_H,
                this.enums.saudeBucalDenteProblemaCondicao.HIGIDO_SELADO_HS,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_PARCIAL_REMOVIVEL,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_TEMPORARIA,
                this.enums.saudeBucalDenteProblemaCondicao.INCLUSO_I,
            ]

            const parte2 = [
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_CORONARIA_UNITARIA,
                this.enums.saudeBucalDenteProblemaCondicao.COROA_CO,
                this.enums.saudeBucalDenteProblemaCondicao.IMPLANTE,
                this.enums.saudeBucalDenteProblemaCondicao.PILAR_P,
                this.enums.saudeBucalDenteProblemaCondicao.NUCLEO_PINO,
            ]

            const parte3 = [
                this.enums.saudeBucalDenteProblemaCondicao.RESTO_RADICULAR_RR,
                this.enums.saudeBucalDenteProblemaCondicao.RETRACAO_GENGIVAL_RG,
                this.enums.saudeBucalDenteProblemaCondicao.CALCULO_DENTAL_CD,
                this.enums.saudeBucalDenteProblemaCondicao.EXTRACAO_INDICADA_EI,
                this.enums.saudeBucalDenteProblemaCondicao.SELANTE_INDICADO_SI,
                this.enums.saudeBucalDenteProblemaCondicao.FRATURA_FR,
                this.enums.saudeBucalDenteProblemaCondicao.MANCHA_BRANCA_ATIVA_M,
                this.enums.saudeBucalDenteProblemaCondicao.CARIADO_C,
                this.enums.saudeBucalDenteProblemaCondicao.RESTAURADO_R,
                this.enums.saudeBucalDenteProblemaCondicao.CARIE_DA_RAIZ,
                this.enums.saudeBucalDenteProblemaCondicao.RESTAURADO_COM_CARIE_RC,
                this.enums.saudeBucalDenteProblemaCondicao.RAIZ_RESTAURADA,
                this.enums.saudeBucalDenteProblemaCondicao.NECESSITA_DE_TRATAMENTO_ENDODONTICO,
                this.enums.saudeBucalDenteProblemaCondicao.POSSUI_LESAO_DE_FURCA,
                this.enums.saudeBucalDenteProblemaCondicao.TRATAMENTO_ENDODONTICO_REALIZADO,
                this.enums.saudeBucalDenteProblemaCondicao.LESAO_DE_FURCA_TRATADA,
                this.enums.saudeBucalDenteProblemaCondicao.MANTENEDOR_DE_ESPACO_ME,
            ]

            const hasParte1Selected = this.model.problemasCondicoes.some(problemaCondicao => parte1.includes(problemaCondicao))
            const hasParte2Selected = this.model.problemasCondicoes.some(problemaCondicao => parte2.includes(problemaCondicao))
            const hasParte3Selected = this.model.problemasCondicoes.some(problemaCondicao => parte3.includes(problemaCondicao))

            if (hasParte1Selected && ((!this.model.problemasCondicoes.includes(id) && parte1.includes(id)) || parte2.includes(id) || parte3.includes(id))) {
                props.disabled = true
            } else if (hasParte2Selected && (parte1.includes(id) || parte3.includes(id))) {
                props.disabled = true
            } else if (hasParte3Selected && (parte1.includes(id) || parte2.includes(id))) {
                props.disabled = true
            }

            return props
        },
        getProblemasCondicoesToDisable() {
            return [
                this.enums.saudeBucalDenteProblemaCondicao.AUSENTE_A,
                this.enums.saudeBucalDenteProblemaCondicao.EXTRAIDO_E,
                this.enums.saudeBucalDenteProblemaCondicao.HIGIDO_H,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_PARCIAL_REMOVIVEL,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_TEMPORARIA,
                this.enums.saudeBucalDenteProblemaCondicao.INCLUSO_I,
            ]
        },
        getArcadas() {
            return this.data.model.odontograma.arcadas
        },
        getDentes() {
            let dentes = []

            if (this.data.model.odontograma.mostrarDentesDeciduos) {
                dentes = dentes.concat(this.getDentesSuperioresDeciduos())
                dentes = dentes.concat(this.getDentesInferioresDeciduos())
            }

            dentes = dentes.concat(this.getDentesSuperioresPermanentes())
            dentes = dentes.concat(this.getDentesInferioresPermanentes())

            return dentes
                .filter(dente => dente.id !== this.model.id)
                .sort((a, b) => a.numero - b.numero)
        },
        getDentesInferioresPermanentes() {
            return this.getArcadas().inferior.dentes.permanentes.map(dente => Object.assign(dente, {nome: `Dente ${dente.numero}`}))
        },
        getDentesInferioresDeciduos() {
            return this.getArcadas().inferior.dentes.deciduos.map(dente => Object.assign(dente, {nome: `Dente ${dente.numero}`}))
        },
        getDentesSuperioresDeciduos() {
            return this.getArcadas().superior.dentes.deciduos.map(dente => Object.assign(dente, {nome: `Dente ${dente.numero}`}))
        },
        getDentesSuperioresPermanentes() {
            return this.getArcadas().superior.dentes.permanentes.map(dente => Object.assign(dente, {nome: `Dente ${dente.numero}`}))
        },
    },
    mixins: [object],
    props: {
        data: {required: true, type: Object},
    },
    watch: {
        'model.problemasCondicoes'(value) {
            if (value.length === 0) {
                this.model.replicarProblemasCondicoesOutrosDentes = []
            }
        },
        'model.procedimentosClinicos'(value) {
            if (value.length === 0) {
                this.model.replicarProcedimentosOutrosDentes = []
            }
        },
    },
}
</script>
